// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as NLOrderPricingStrategyVm from "./vm-mapper/NLOrderPricingStrategyVm.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";

var calculator_icon = OrderDashboardAssetsManager.getImage("calculator.svg");

function getViewLabel(pricing_strategy) {
  return {
          hd: {
            label: "Create Trip Fare Strategy",
            value: {
              TAG: /* Text */0,
              _0: pricing_strategy.create_fare_trip_strategy
            }
          },
          tl: {
            hd: {
              label: "Pickup Vicinity Passed",
              value: {
                TAG: /* Text */0,
                _0: pricing_strategy.pickup_vicinity_passed
              }
            },
            tl: {
              hd: {
                label: "End Trip Fare Strategy",
                value: {
                  TAG: /* Text */0,
                  _0: pricing_strategy.end_fare_trip_strategy
                }
              },
              tl: {
                hd: {
                  label: "Drop Vicinity Passed",
                  value: {
                    TAG: /* Text */0,
                    _0: pricing_strategy.drop_vicinity_passed
                  }
                },
                tl: {
                  hd: {
                    label: "Breach Type",
                    value: {
                      TAG: /* Text */0,
                      _0: pricing_strategy.breach_type
                    }
                  },
                  tl: {
                    hd: {
                      label: "Waiting Time Passed",
                      value: {
                        TAG: /* Text */0,
                        _0: pricing_strategy.waiting_time_passed
                      }
                    },
                    tl: {
                      hd: {
                        label: "New fixed fare>fixed fare",
                        value: {
                          TAG: /* Text */0,
                          _0: pricing_strategy.new_fixed_fare_fixed_greater
                        }
                      },
                      tl: {
                        hd: {
                          label: "Waypoint Vicinity Passed",
                          value: {
                            TAG: /* Text */0,
                            _0: pricing_strategy.waypoint_vicinity_passed
                          }
                        },
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function NLOrderPricingStrategy(Props) {
  var order = Props.order;
  var pricing_strategy = NLOrderPricingStrategyVm.getVm(order);
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement(CardTitleWithImage.make, {
                                title: "Pricing Strategy",
                                icon_src: calculator_icon
                              });
                  })
              },
              action: undefined,
              className: "primary-info-card payment-info",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(pricing_strategy))
                  })
            });
}

var make = NLOrderPricingStrategy;

export {
  calculator_icon ,
  getViewLabel ,
  make ,
  
}
/* calculator_icon Not a pure module */
